import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Bridge } from './components/sections/Bridge';
import { Volumes } from './components/sections/Volumes';
import { Delivery } from './components/sections/Delivery';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalChoice } from './components/sections/FinalChoice';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-full overflow-x-hidden bg-cream font-sans antialiased" data-id="element-0" data-mp="3ijpef4c7z5bc">
      <MetaPixel data-id="element-1" data-mp="3mjq1fdddwou0" />
      <Hero data-id="element-2" data-mp="3mj6ibtbzzuee" />
      <main data-id="element-3" data-mp="3rc9dg5wfbbwp">
        <Stats data-id="element-4" data-mp="3rbr9en3irte8" />
        <BeforeAfter data-id="element-5" data-mp="3rbzq6q2rjiup" />
        <PainPoints data-id="element-6" data-mp="3rcsyhvhdegey" />
        <Bridge data-id="element-7" data-mp="3recdlirailf5" />
        <Volumes data-id="element-8" data-mp="5yimri0b7dt" />
        <Delivery data-id="element-9" data-mp="6hp9c27i9cj" />
        <Bonuses data-id="element-10" data-mp="4wx1t3d72hu" />
        <Offer data-id="element-11" data-mp="5gg5d4r3wxg" />
        <Guarantee data-id="element-12" data-mp="82kl3wchwbg" />
        <Testimonials data-id="element-13" data-mp="2zl3brl12165b" />
        <About data-id="element-14" data-mp="2zlv6ktmtuzuj" />
        <Faq data-id="element-15" data-mp="2zm4v0cs84yy4" />
        <FinalChoice data-id="element-16" data-mp="2zmo6bandcp36" />
      </main>
      <Footer data-id="element-17" data-mp="33mouhn09senf" />
      <FloatingCta triggerId="hero-cta" data-id="element-18" data-mp="33mf0zpg0npcz" />
      <PurchasePopup data-id="element-19" data-mp="33n6zp94wu37h" />
    </div>;
}